// extracted by mini-css-extract-plugin
export default {"container":"TeaserOverlay_container__BmhXo"};